import { getAuthToken } from "./GlobalApi";
import { APIHeader } from "../Helpers";

const url = process.env.REACT_APP_API_URL;

const getHomeInfo = async (id: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "get-home-info"; // TODO: FIND OUT ACTUAL SUFFIX
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const getHomeDrawRequestsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/infolist";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getRequestDrawLoanInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getRequestDrawBankInfolist = async (loanId, proxyUserId: string | undefined = undefined) => {
  const suffix = `bankaccount/list-borrower-bank-info/${loanId}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const validateLoanDraw = async (loanPropertyId, proxyUserId) => {
  const suffix = `draws/validate-loan-draw-app/${loanPropertyId}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ loanPropertyId: loanPropertyId })
  });
};

const getLoanDrawDetails = async (loanDrawApplicationId, proxyUserId) => {
  const suffix = `draws/application-details/${loanDrawApplicationId}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const getLoanDrawDetailVendors = async (loanDrawApplicationId, proxyUserId) => {
  const suffix = `draws/application-detail-vendors/${loanDrawApplicationId}`; //TODO: waiting for shankar
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const getBorrowerVendorList = async (loanId, proxyUserId) => {
  const suffix = `borrowerapplication/borrower-vendors/${loanId} `; 
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const addNewVendor = async (vendorObj, proxyUserId: string | undefined = undefined) => {
  const suffix = "vendors"; 
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(vendorObj)
  });
};

const deleteLoanDrawRequest = async (loanDrawApplicationId, proxyUserId) => {
  const suffix = `draws/loan-draw-application/${loanDrawApplicationId}`; //TODO: tested, error, notified Shankar
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
  });
};

const getLoanDrawAttachments = async (loanDrawApplicationId, proxyUserId) => {
  const suffix = `draws/document-list/${loanDrawApplicationId}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const addLoanDrawAttachment = async (attachment, proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/document"; 
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(attachment)
  });
};

const deleteLoanDrawAttachment = async (loanDrawApplicationId, proxyUserId) => {
  const suffix = `draws/document/${loanDrawApplicationId}`; 
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
  });
};

const updateLoanDrawApplicationDetails = async (loanDrawDetails, proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/process-application-details";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(loanDrawDetails)
  });
};

const getHomeBorrowerStatementsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/statements";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getHomePaymentsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "loans/payments";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getHomeProjectsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "draws/projects";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getHomeBorrowerApplicationsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "borrowerapplication/infolist";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getPaidAchPaymentsInfolist = async (proxyUserId: string | undefined = undefined) => {
    const suffix = "payment/paid-ach-payments";
    const headers = APIHeader(proxyUserId, await getAuthToken());
    return await fetch(`${url}${suffix}`, {
      method: "GET",
      headers: headers
    });
};

const getPendingApprovalInfolist = async (proxyUserId: string | undefined = undefined) => {
    const suffix = "draws/pending-approval";
    const headers = APIHeader(proxyUserId, await getAuthToken());
    return await fetch(`${url}${suffix}`, {
      method: "GET",
      headers: headers
    });
};

const getVendorInfolist = async (proxyUserId: string | undefined = undefined) => {
    const suffix = "vendors/my-vendors";
    const headers = APIHeader(proxyUserId, await getAuthToken());
    return await fetch(`${url}${suffix}`, {
      method: "GET",
      headers: headers
    });
};

const resendVendorInvite = async (inviteObj, proxyUserId: string | undefined = undefined) => {
  const suffix = "vendors/resend-invite";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(inviteObj)
  });
};

const getPayoffQuotelist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "payoffquotes/payoff-list";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const createPayoffQuoteRequest = async (newPayoffQuoteRequest, proxyUserId: string | undefined = undefined) => {
  const suffix = "payoffquotes/create-payoffquoterequest";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(newPayoffQuoteRequest)
  });
};

const getPayoffQuoteLoanList = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "payoffquotes/loan-property-units";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getProjectsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/inspection-projects";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getInspectionProjectDetails = async (id: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/inspection-project-details";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const getInspectionProjectDocuments = async (id: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/inspection-project-doc-logs";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const getInspectionProjectInspections = async (id: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/inspection-project-work-inspections";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const getCurrentInspectionsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/current-inspections";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getCurrentWorkInspectionInfo = async (inspectionId: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/current-inspection";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${inspectionId}`, {
    method: "GET",
    headers: headers
  });
};

const updateCurrentInspection = async (inspection, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/update-current-inspection";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(inspection)
  });
};

const downloadWorkInspectionDocument = async (nwccInspectionId: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/download-work-inspection-doc";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${nwccInspectionId}`, {
    method: "GET",
    headers: headers
  });
};

const updateCurrentInspectionDetails = async (updatedInspectionList, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/update-current-inspection-details";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(updatedInspectionList)
  });
};

const getCurrentWorkInspectionDetailInfo = async (inspectionId: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/current-inspection-details";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${inspectionId}`, {
    method: "GET",
    headers: headers
  });
};

const getCurrentWorkInspectionDocuments= async (nwccinspectionId: string | undefined = undefined, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/current-inspection-docs";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${nwccinspectionId}`, {
    method: "GET",
    headers: headers
  });
};

const completeCurrentInspection = async (inspectionId, proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/complete-current-inspection"; // TODO: find out actual endpoint. not in documentaion
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(inspectionId)
  });
};

const getRequestedInspectionsInfolist = async (proxyUserId: string | undefined = undefined) => {
  const suffix = "inspections/requested-inspections";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getPastInspectionsInfolist = async (proxyUserId: string | undefined = undefined, startDate: string, endDate: string) => {
  const suffix = "inspections/past-inspections";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  const params = new URLSearchParams({"startDate": startDate, "endDate": endDate});
  return await fetch(`${url}${suffix}?${params.toString()}`, {
    method: "GET",
    headers: headers
  });
};

export { 
  getHomeInfo,
  getHomeDrawRequestsInfolist,
  getRequestDrawLoanInfolist,
  getRequestDrawBankInfolist,
  validateLoanDraw,
  getLoanDrawDetails,
  getLoanDrawDetailVendors,
  getBorrowerVendorList,
  addNewVendor,
  deleteLoanDrawRequest,
  getLoanDrawAttachments,
  addLoanDrawAttachment,
  deleteLoanDrawAttachment,
  updateLoanDrawApplicationDetails,
  getHomeBorrowerStatementsInfolist,
  getHomePaymentsInfolist,
  getHomeProjectsInfolist,
  getHomeBorrowerApplicationsInfolist,
  getPaidAchPaymentsInfolist,
  getPendingApprovalInfolist,
  getVendorInfolist,
  resendVendorInvite,
  getPayoffQuotelist,
  createPayoffQuoteRequest,
  getPayoffQuoteLoanList,
  getProjectsInfolist,
  getInspectionProjectDetails,
  getInspectionProjectDocuments,
  getInspectionProjectInspections,
  getCurrentInspectionsInfolist,
  getCurrentWorkInspectionInfo,
  updateCurrentInspection,
  downloadWorkInspectionDocument,
  updateCurrentInspectionDetails,
  getCurrentWorkInspectionDetailInfo,
  getCurrentWorkInspectionDocuments,
  completeCurrentInspection,
  getRequestedInspectionsInfolist,
  getPastInspectionsInfolist
};